import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { SIGN_BY_SLUG } from '../../data/astro/signs';
import { parsePairSlug } from '../../data/compatibility';
import CompatibilitySign from './CompatibilitySign';
import CompatibilityPair from './CompatibilityPair';

const CompatibilityRoute = () => {
  const { slug } = useParams();
  if (SIGN_BY_SLUG[slug]) return <CompatibilitySign key={slug} sign={slug} />;
  const pair = parsePairSlug(slug);
  if (pair) return <CompatibilityPair man={pair.man} woman={pair.woman} />;
  return <Navigate to="/zodiac-compatibility/" replace />;
};

export default CompatibilityRoute;
